import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-durham-learn-outside',
  templateUrl: './durham-learn-outside.component.html',
  styleUrls: ['./durham-learn-outside.component.scss']
})
export class DurhamLearnOutsideComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
